export default [
  {
    chName: '期中期末',
    value: 'mijuan_qizhongqimo'
  },
  {
    chName: '单元测试',
    value: 'mijuan_danyuanceshi'
  },
  {
    chName: '专题密卷',
    value: 'mijuan_zhuantishijuan'
  },
  {
    chName: '升学考试',
    value: 'mijuan_shengxuekaoshi'
  }
]
